import tw from 'twin.macro';
import styled from '@emotion/styled';
import HamburgerButton from '@/components/Header/components/HamburgerButton/HamburgerButton';

export const StyledToggle = styled.div`
  ${tw`flex`}
  ${tw`ml-auto`}
  ${tw`text-right`}
  ${tw`lg:hidden`}
`;

export const SecondaryMenuWrapper = styled.div<{ isSecondaryNavOpen: boolean }>`
  ${tw`text-left`}

  ${tw`z-20`}
  ${tw`w-full max-h-0`}
  ${tw`absolute top-full left-0`}
  ${tw`overflow-hidden`}
  ${tw`transition-[max-height] duration-300 ease-in-out`}
  ${tw`lg:mt-0`}
  ${tw`lg:z-auto lg:flex-1`}
  ${tw`lg:w-auto lg:h-auto lg:max-h-screen`}
  ${tw`lg:relative lg:top-[unset] lg:left-[unset]`}
  ${tw`lg:overflow-visible`}
  ${({ isSecondaryNavOpen }) => isSecondaryNavOpen && tw`max-h-screen`}
`;

export const HamburgerMenu = styled(HamburgerButton)`
  ${tw`p-0`}
`;
